import { useWeb3React } from "@web3-react/core";
import { InjectedConnector } from "@web3-react/injected-connector";

import React, { useCallback, useState } from "react";
import { Button, Container, Form, Image, Row } from "react-bootstrap";
import axios from "axios";
import { BASE_URL, Injected } from "../constants";
import Logo from "../assets/ember.svg";
import Loader from "../components/Loader";
import {
  getErrorMessage,
  handleFormValidation,
  showAlert,
  userNameValidation,
} from "../utils/";

const RegistrationForm = () => {
  const [guildName, setGuildName] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [encryptedKey, setEncryptedKey] = useState("");

  const [walletloading, setWalletLoading] = useState(false);
  const [registrationloading, setRegistrationLoading] = useState(false);

  const { active, connector, account, activate } = useWeb3React();

  const connectWallet = () => {
    !active &&
      !(connector instanceof InjectedConnector) &&
      activateWallet(Injected);
  };

  const activateWallet = useCallback(
    (connector?: InjectedConnector, onClose?: any) => {
      setWalletLoading(true);
      if (connector) {
        activate(connector, undefined, true)
          .then(res => {
            setWalletLoading(false);
          })
          .catch(e => {
            const err = getErrorMessage(e);
            setWalletLoading(false);
            showAlert(true, err);
          });
      }
    },
    [account]
  );

  const handleSubmit = async () => {
    try {
      setRegistrationLoading(true);

      const isOk = handleFormValidation(password, username, confirmPassword);

      if (isOk) {
        await getEncryptionKeys();
        await axios.post(`${BASE_URL}/registration/addGuild`, {
          guildName: guildName.replace(/\s/g, ""),
          username: username.replace(/\s/g, ""),
          password,
          guildAddress: account?.toLowerCase(),
          publicKey: encryptedKey,
        });
        showAlert(false, "Guild Successfully Onboarded!");
        setUsername("");
        setPassword("");
        setConfirmPassword("");
        setGuildName("");
      }
      setRegistrationLoading(false);
    } catch (error: any) {
      if (error.response?.data?.msg?.includes("username")) {
        showAlert(true, "Cannot use duplicate username");
      } else if (error.response?.data?.msg?.includes("guildAddress")) {
        showAlert(true, "Cannot use duplicate wallet address");
      } else {
        showAlert(true, "Something went wrong");
      }
      setRegistrationLoading(false);
    }
  };

  const getEncryptionKeys = async () => {
    if (window?.ethereum) {
      const keys = await window.ethereum?.request({
        method: "eth_getEncryptionPublicKey",
        params: [account],
      });
      setEncryptedKey(keys);
    }
  };

  return (
    <Container className='center' fluid>
      <Row className='main-container'>
        <Image src={Logo} height={70} className='spacing' />
        <h2 className='center-content spacing'>Create a new account</h2>
        <Form>
          <Form.Group className='mb-4'>
            <Form.Control
              placeholder='Guild Name'
              size='lg'
              className='input-spacing'
              value={guildName}
              onChange={e => setGuildName(e.target.value)}
            />
          </Form.Group>

          <Form.Group className='mb-4'>
            <Form.Control
              placeholder='Username'
              size='lg'
              className='input-spacing'
              value={username}
              onChange={e => setUsername(e.target.value)}
            />
            <p className='text-muted align'>
              Allowed Special Characters: underscore (_), dash (-), period (.)
            </p>
          </Form.Group>

          <Form.Group className='mb-4'>
            <Form.Control
              type='password'
              placeholder='Password'
              size='lg'
              className='input-spacing'
              value={password}
              onChange={e => setPassword(e.target.value)}
            />
          </Form.Group>

          <Form.Group className='mb-4'>
            <Form.Control
              type='password'
              placeholder='Confirm Password'
              size='lg'
              className='input-spacing'
              value={confirmPassword}
              onChange={e => setConfirmPassword(e.target.value)}
            />
          </Form.Group>

          {account ? (
            <h6 className='center-content spacing'>
              Connected Account: {account}
            </h6>
          ) : walletloading ? (
            <Loader />
          ) : (
            <Button size='lg' className='btn-spacing' onClick={connectWallet}>
              Connect Wallet
            </Button>
          )}

          {registrationloading ? (
            <Loader />
          ) : (
            <Button
              size='lg'
              className='btn-spacing'
              onClick={handleSubmit}
              disabled={
                !username ||
                !guildName ||
                !password ||
                !confirmPassword ||
                !account
              }
            >
              Create Account
            </Button>
          )}
        </Form>
      </Row>
    </Container>
  );
};

export default RegistrationForm;
